import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faEdit, faInfoCircle, faMoneyCheckAlt, faPlusCircle, fas, faTrash } from '@fortawesome/free-solid-svg-icons';
import { ConfigurationPfacComponent } from './configuration-pfac.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AddPfacComponent } from './components/add-pfac/add-pfac.component';
import { AuditPfacComponent } from './components/audit-pfac/audit-pfac.component';
import { FdFormComponentsModule } from '../shared/fd-form-components/fd-form-components.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatDialogModule } from '@angular/material/dialog';
import { ListPfacComponent } from './components/list-pfac/list-pfac.component';
import { EditPfacComponent } from './components/edit-pfac/edit-pfac.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CpfCnpjPipe } from '../shared/pipes/cpf-cnpj.pipe';
import { PipesModule } from '../shared/pipes/pipes.module';


@NgModule({
  declarations: [
    ConfigurationPfacComponent,
    AddPfacComponent,
    AuditPfacComponent,
    ListPfacComponent,
    EditPfacComponent,
  ],
  imports: [
    CommonModule,
    FontAwesomeModule,
    FormsModule,
    ReactiveFormsModule,
    FdFormComponentsModule,
    FlexLayoutModule,
    MatDialogModule,
    MatPaginatorModule,
    MatTableModule,
    MatTooltipModule,
    MatFormFieldModule,
    PipesModule
  ],
  providers: [CpfCnpjPipe]
})
export class ConfigurationPfacModule {
  constructor(library: FaIconLibrary) {
      library.addIconPacks(fas)
      library.addIcons(faEdit, faMoneyCheckAlt, faPlusCircle, faTrash, faInfoCircle);
    }
 }
